import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showPDPTopOfPageRedesignSelector = createSelector(testTargetOffersSelector, offers => offers.showPDPTopOfPageRedesign || Empty.Object);

export { showPDPTopOfPageRedesignSelector };
